import positionLevel from '@/api/hr/position-level'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return positionLevel.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return positionLevel.store(data)
  },

  update(context, { id, data }) {
    return positionLevel.update(id, data)
  },

  destroy(context, id) {
    return positionLevel.destroy(id)
  }
}
